export enum CatalogUserEvents {
    CatalogTooltipClickMetricLink = "Catalog Tooltip - Click Metric Link",
    CatalogTooltipClickReferenceDataLink = "Catalog Tooltip - Click Reference Data Link",
    ClickCatalogListItem = "Catalog - Click List Item",
    ClickFeaturedCard = "Catalog - Click Featured Card",
    ClickSidebarMetricLink = "Catalog Sidebar - Click Metric Link",
    ClickSidebarReferenceDataLink = "Catalog Sidebar - Click Reference Data Link",
}
